<div class="property-list-item" (click)="selectStage(projectStage())"
    [class.is-for-sale]="projectStage().saleStateTypes?.includes(EVNDSaleStateType.Forsale)">
    <div class="estate-type-icon" [class]="estateTypeCssClass()"></div>
    
    @if (projectStage().saleStateTypes?.includes(EVNDSaleStateType.Withdrawn)) {
        <div class="withdrawn">T</div>
    }

    <div class="address">{{ projectStage().projectName }}</div>
    <div class="stages">{{ projectStage().numStages }} Trinn</div>
    <div class="progress-bar">
        <div class="progress-text">{{ soldPercentage() }}%</div>
        <ev-progress-bar [width]="'50px'" [height]="'12px'" [progress]="soldRatio()"
            [theme]="soldPercentage() == 100 ? 'green' : 'blue'"></ev-progress-bar>
    </div>
</div>